import React, { useState } from "react";
import { Accordion } from "@my-scoot/component-library-legacy";
import { REFERRAL_FAQS_CONSTANTS } from "./ReferralFaq.constants";

export const ReferralFaq = ({ referralOverview }) => {
  const { TITLE, ITEMS } = REFERRAL_FAQS_CONSTANTS;
  const [expandedId, setExpandedId] = useState(null);

  const rate = referralOverview?.commission_rate ?? 25;

  const handleToggle = (id) => (event, isExpanded) => {
    setExpandedId(isExpanded ? id : null);
  };

  return (
    <section className="tw-w-full tw-my-10">
      <h2 className="tw-text-xl tw-font-bold tw-text-slate-900 tw-m-0 tw-mb-6">
        {TITLE}
      </h2>

      <div className="tw-border-t tw-border-r-0 tw-border-l-0 tw-border-b-0 tw-border-solid tw-border-[#EEECF5]">
        {ITEMS.map((item) => {
          const answer =
            item.ID === 3
              ? `No. You earn a flat ${rate}% commission on every successful referral, with no cap.`
              : item.ANSWER;

          return (
            <div
              key={item.ID}
              className="tw-border-b tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-border-solid tw-border-[#EEECF5]"
            >
              <Accordion
                expandIconPosition="end"
                expanded={expandedId === item.ID}
                onChange={handleToggle(item.ID)}
                className="!tw-shadow-none !tw-border-0 !tw-rounded-none !tw-bg-transparent !tw-m-0 before:!tw-hidden"
                summaryClassName="!tw-py-[18px] !tw-px-0 !tw-min-h-0 [&>div]:!tw-m-0"
                accordionSummaryContent={
                  <span className="tw-text-base tw-font-medium tw-text-slate-900">
                    {item.QUESTION}
                  </span>
                }
              >
                <div className="tw-text-[15px] tw-leading-relaxed tw-text-[#635F78] tw-pb-4 tw-pt-1 tw-max-w-[720px]">
                  {answer}
                </div>
              </Accordion>
            </div>
          );
        })}
      </div>
    </section>
  );
};
